import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=132b378e&scoped=true&"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts&"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=132b378e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b378e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132b378e')) {
      api.createRecord('132b378e', component.options)
    } else {
      api.reload('132b378e', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=132b378e&scoped=true&", function () {
      api.rerender('132b378e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/Breadcrumb.vue"
export default component.exports